export const syncReadFile = (file, callback = () => { }) => {
  const reader = new FileReader();
  reader.onload = function fileReadCompleted() {
    callback(reader.result);
  };
  reader.readAsText(file);
};

const JSZip = require('jszip');
const FileSaver = require('file-saver');

export function downloadImagesAsZip(images, folderName='SW_IMAGES') {
  const zip = new JSZip();
  images.forEach((image, index) => {
    fetch(image)
      .then(response => response.blob())
      .then(blob => {
        zip.file(`image_${index + 1}.jpg`, blob);
        if (index === images.length - 1) {
          zip.generateAsync({ type: 'blob' }).then(content => {
            FileSaver.saveAs(content, folderName + '.zip');
          });
        }
      });
  });
}
